/**
 * O ranking em UMA linha na Home (Home v2, PO 19/09/2026): "Você está em
 * 2º · faltam R$ 100 para passar Maria". As frases alternam por dia para não
 * cansar — todas a partir de dados reais do ranking; nada inventado. Só em
 * grupo, só com a feature ligada, só quando há o que dizer.
 *
 * Frases geradas por IA (com categorias, "está de dieta?") são ideia futura
 * (Visão §10.3c) — aqui é regra simples.
 */
import { featureEnabled, formatMoney, RANKING_TITLE_LABELS } from '@nv/core';
import { useNavigate } from 'react-router-dom';

import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { useRanking } from './api';

function primeiroNome(nome: string): string {
  return nome.trim().split(/\s+/)[0] ?? nome;
}

export function fraseDoRanking(r: { people: { memberId: string; name: string; totalMinor: number; position: number }[]; me: { memberId: string; position: number | null; totalMinor: number; titles: string[] } }, currency: string, semente: number): string | null {
  const { me, people } = r;
  if (me.position === null || people.length < 2) return null;
  const dinheiro = (v: number) => formatMoney(v, currency, { hideCents: true });
  const frases: string[] = [];
  if (me.position === 1) {
    const segundo = people.find((p) => p.position === 2);
    if (segundo) frases.push(`Você lidera o ranking · ${primeiroNome(segundo.name)} está ${dinheiro(me.totalMinor - segundo.totalMinor)} atrás`);
    else frases.push('Você lidera o ranking');
  } else {
    const acima = people.find((p) => p.position === me.position! - 1);
    if (acima) frases.push(`Você está em ${me.position}º · faltam ${dinheiro(acima.totalMinor - me.totalMinor)} para passar ${primeiroNome(acima.name)}`);
    const lider = people.find((p) => p.position === 1);
    if (lider && lider.memberId !== acima?.memberId) frases.push(`${primeiroNome(lider.name)} lidera com ${dinheiro(lider.totalMinor)} · você está em ${me.position}º`);
  }
  const titulo = me.titles[0];
  if (titulo && titulo in RANKING_TITLE_LABELS) frases.push(`Você tem o título "${RANKING_TITLE_LABELS[titulo as keyof typeof RANKING_TITLE_LABELS].nome}" · ver o ranking`);
  if (frases.length === 0) return null;
  return frases[Math.abs(semente) % frases.length] ?? null;
}

export function RankingNaHome({ currency }: { currency: string }) {
  const navigate = useNavigate();
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'ranking');
  const ranking = useRanking(tripId, ligado);
  if (!ligado || !ranking.data) return null;
  // Semente do dia: a frase muda a cada dia, não a cada render.
  const frase = fraseDoRanking(ranking.data, currency, Math.floor(Date.now() / 86_400_000));
  if (!frase) return null;
  return (
    <button type="button" className="rk-home" onClick={() => navigate('/ranking')} data-testid="home-ranking">
      <span className="rk-home__icone" aria-hidden="true"><Icon name="trofeu" size={16} /></span>
      <span className="rk-home__texto">{frase}</span>
      <Icon name="avancar" size={16} />
    </button>
  );
}
